export default __webpack_public_path__ + "mysql.5b74952d.png";